import { render, staticRenderFns } from "./SuperProductoRegistra.vue?vue&type=template&id=3d3f5ab5&"
import script from "./SuperProductoRegistra.vue?vue&type=script&lang=js&"
export * from "./SuperProductoRegistra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports